<template>
<h2>Schedule for Gate {{ gate.gate }}</h2>
<div class="schedule-week" v-for="entry in gate.gateCalendar" :key="entry.label">
  <p>Week of {{ entry.label }}</p>
  <table>
    <thead>
      <td>Name</td>
      <td>Start</td>
      <td>End</td>
    </thead>
    <tbody>
      <tr v-for="person in entry.entries" :key="person.name">
        <td>{{ person.name }}</td>
        <td>{{ person.start }}</td>
        <td>{{ person.end }}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
  inject: ['gateData'],
  data() {
    return {
      gate: {}
    }
  },
  methods: {
    
  },
  created() {
    const theGate = Number(this.$route.params.gateID);
    const theGateData = this.gateData.find(gate => gate.gate === theGate);
    this.gate = theGateData;

    console.log(this.gate);
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}

thead td {
  font-weight: 700;
}

td {
  border: 1px solid #aaa;
  margin: 0;
  padding: 5px 10px;
}
</style>